var invariantFor = function invariantFor(type) {
  return function (condition, parameter, value, message) {
    var source = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "/image_transformation_reference#" + parameter + "_parameter";

    if (!condition) {
      value = typeof value === 'string' ? "'" + value + "'" : value;
      source = source ? "http://cloudinary.com/documentation" + source : null;
      throw new Error("Cloudinary " + type + ":: " + parameter + " " + message + ", received: " + value + (source ? " - see " + source : ''));
    }
  };
};

export var invariant = invariantFor('');
export var invariantImage = invariantFor('Image ');
export var invariantVideo = invariantFor('Video ');
export var isNumber = function isNumber(value) {
  return typeof value === 'number' || !Number.isNaN(Number(value));
};
export var startsWith = function startsWith(needle, haystack) {
  return haystack.indexOf(needle) === 0;
};
export var includes = function includes(needle, haystack) {
  return haystack.indexOf(needle) > -1;
};
export var shouldBeOneOf = function shouldBeOneOf(possibleValues) {
  return "should be one of ['" + possibleValues.join("', '") + "']";
};